const accessToken = process.env.REACT_APP_INSTAGRAM_ACESS_TOKEN;
const mediaUrl = `https://graph.instagram.com/me/media?fields=media_url,permalink,media_type&access_token=${accessToken}`;

export const getInstagramData = () => fetch(mediaUrl);
